<script setup lang="ts">
/** BON03 — Letter of Allotment (Bonus Issue). 회사 → 수배자 통지. */
import { computed, inject } from 'vue';
import { BONUS_DOC_CTX } from './bonusContext';
import BonusDocVarField from './BonusDocVarField.vue';
import BonusDocHead from './parts/BonusDocHead.vue';
import BonusAllotteeTable from './parts/BonusAllotteeTable.vue';
import BonusSigners from './parts/BonusSigners.vue';

const ctx = inject(BONUS_DOC_CTX)!;
const hasConstitution = computed(() => ctx.flag('has_constitution'));
</script>

<template>
  <div class="allot-doc">
    <BonusDocHead />
    <p class="doc-p" style="text-align:right"><BonusDocVarField field-key="letter_date" /></p>

    <p class="doc-sec-title">LETTER OF ALLOTMENT — BONUS ISSUE</p>
    <p class="doc-p">Dear Shareholder(s),</p>
    <p class="doc-p">
      We are pleased to inform you that, pursuant to the resolution of the members and the
      <span class="doc-toggle" @click="ctx.toggleFlag('has_constitution')">{{ hasConstitution ? "Constitution of the Company" : "Companies Act 2016" }}</span>,
      the sum of RM<BonusDocVarField field-key="capitalized_amount" /> standing to the credit of the Company's reserves has been capitalised and
      applied in paying up in full new ordinary shares which are hereby allotted and credited as fully paid-up bonus shares to you as follows:
    </p>

    <BonusAllotteeTable />

    <p class="doc-p" style="margin-top:12px">
      The said bonus shares rank pari passu in all respects with the existing ordinary shares of the Company. No payment is required from you in
      respect of the said bonus shares. Kindly contact the Company Secretary should you require any clarification.
    </p>
    <p class="doc-p">Yours faithfully,<br />For and on behalf of<br /><b><BonusDocVarField field-key="company_name" /></b></p>
    <BonusSigners var-key="letter" />

    <p class="doc-attn">
      Company Secretary: <BonusDocVarField field-key="cosec_name" />, <BonusDocVarField field-key="cosec_address" />
    </p>
  </div>
</template>
